import React from "react";
import { goToTop } from "helpers/helpers";

export default function NavigateButtons({ currentStep, setCurrentStep, back, next, finalize }) {
   const goBack = () => {
      setCurrentStep(currentStep - 1);
      localStorage.setItem("sessionCurrentStep", currentStep - 1);
      goToTop();
   };
   return (
      <>
         {next === "displayNone" ? (
            <div className="text-center mt-50 mb-50">
               <a onClick={() => goBack()} className="t-decoration link-one bg-white color-gray2 font-weight-400 cursor-pointer">
                  Înapoi
               </a>
            </div>
         ) : next === "hide" ? (
            <div className="text-center mt-50 mb-50">
               <p className="mt-20 text-center">Se procesează cererea...</p>
            </div>
         ) : (
             <div style={{paddingTop: "30px" }} className="text-center mt-50">
               <a onClick={() => goBack()} className={`${back} dont-agree second-link mr-3 color-gray2 font-weight-400 cursor-pointer`}>
                  Înapoi
               </a>
               <button type="submit" className={`${next} link-one bg-white`}>
                  {finalize ? "Finalizează" : "Continuă"}
               </button>
            </div>
         )}
      </>
   );
}
